
import {DDocumentoPendienteVista} from './ddocumento-pendiente-vista';

export class DDocumentosPendientesVista {
    
    dDocumentosPendientes:Array<DDocumentoPendienteVista>;
    
    constructor(){        
        this.dDocumentosPendientes =  new Array<DDocumentoPendienteVista>();
    }
    
}


// WEBPACK FOOTER //
// D:/AngularProjects/Angular Projects/Formularios/src/app/to/ddocumentos-pendientes-vista.ts